export enum documentTypes {
    DOCUMENT_DATA = 'DOCUMENT_DATA',
    DOCUMENT_AUDIT_DATA='DOCUMENT_AUDIT_DATA',
    DOCUMENT_TYPE_DATA = 'DOCUMENT_TYPE_DATA',
    DOCUMENT_LOADING = 'DOCUMENT_LOADING',
    DOCUMENT_SEARCH_PAYLOAD= 'DOCUMENT_SEARCH_PAYLOAD'
}